import axios from "axios";
import connConfig from "@/services/connConfig";



export default class RawDataServiceTemplate {
  
  constructor(url) {
    this.url = url;
    this.getAllParams = undefined;
  }

  setFilter(params) {
    this.getAllParams = { params };
  }

  async getAll() {
    try {
      let res = await axios.get(this.url, connConfig.connData(this.getAllParams));
      //console.log(res.data);
      return res.data;
    } catch (e) {
      let res = e.response.data;
      if(e.response.status==401){
        location.reload();
      }
      e.isOk = false;
      e.message = res?.message || "Error: Server comm error";
      e.message_es = res?.message_es || "Error: ha ocurrido un error de comunicación";
      e.data = [];
      throw e
    }
  }

  async getByKey(key) {
    try {
      let res = await axios.get(`${this.url}/${key}`, connConfig.connData());
      return res.data;
    } catch (e) {
      let res = e.response.data;
      if(e.response.status==401){
        location.reload();
      }
      e.message = res?.message || "Error: Server comm error";
      e.message_es = res?.message_es || "Error: ha ocurrido un error de comunicación";
      e.data = {};
      throw e
    }
  }

  async create(values) {
    try {
      let res = await axios.post(this.url, values, connConfig.connData());
      return res.data;
    } catch (e) {
      let res = e.response.data;
      if(e.response.status==401){
        location.reload();
      }
      e.isOk = false;
      e.message = res?.message || "Creation failed by an unexpected error";
      e.message_es = res?.message_es || "Error: ha ocurrido un error desconocido al crear";
      e.data = res;
      throw e
    }
  }

  async update(key, values) {
    /**** data not to send to backend can be filtered here */
    delete values.non_editable_property;
    try {
      let res = await axios.put(`${this.url}/${key}`, values, connConfig.connData()); 
      return res.data;
    } catch (e) {
      
      let res = e.response.data;
      if(e.response.status==401){
        location.reload();
      }
      e.message = res?.message || "Edition failed by an unexpected error";
      e.message_es = res?.message_es || "Error: ha ocurrido un error desconocido al guardar cambios";
      e.data = res;
      throw e
    }
  }

  async remove(key) {
    try {
      let res = await axios.delete(`${this.url}/${key}`, connConfig.connData());
      return res.data;
    } catch (e) {
      let res = e.response.data;
      if(e.response.status==401){
        location.reload();
      }
      e.message = res?.message || "Deletion failed by an unexpected error";
      e.message_es = res?.message_es || "Error: ha ocurrido un error desconocido al eliminar el registro";
      e.data = res;
      throw e
    }
  }

  async sendPatch(key, values) {
    try {
      let res = await axios.patch(`${this.url}/${key}`, values, connConfig.connData());
      return res.data;
    } catch (e) {
      let res = e.response.data;
      if(e.response.status==401){
        location.reload();
      }
      e.message = res?.message || "Register change failed by an unexpected error";
      e.message_es = res?.message_es || "Error: ha ocurrido un error desconocido al editar el registro";
      e.data = res;
      throw e
    }
  }
}